import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthApiService } from './services/auth-api.service';

/**
 * Ensures requests send auth cookies and redirects to login on 401,
 * except for the auth endpoints themselves (to avoid redirect loops).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authApi = inject(AuthApiService);

  const authEndpoints = ['/auth/user', '/auth/login', '/auth/logout', '/auth/status', '/auth/callback'];
  const normalizedUrl = req.url.toLowerCase();
  const isAuthEndpoint = authEndpoints.some((endpoint) => normalizedUrl.includes(endpoint));

  const authReq = req.withCredentials ? req : req.clone({ withCredentials: true });

  return next(authReq).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401 && !isAuthEndpoint) {
        const currentUrl = window.location.pathname + window.location.search;
        authApi.redirectToLogin(currentUrl);
      }

      return throwError(() => error);
    })
  );
};
